import { render, staticRenderFns } from "./HelpCenterDetail.vue?vue&type=template&id=c5daf4e4&scoped=true&"
import script from "./HelpCenterDetail.vue?vue&type=script&lang=js&"
export * from "./HelpCenterDetail.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterDetail.vue?vue&type=style&index=0&id=c5daf4e4&lang=scss&scoped=true&"
import style1 from "./HelpCenterDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5daf4e4",
  null
  
)

export default component.exports